import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import ActionsApp from '@sharedComponent/app-action-reducer/action';
import Selectors from '@sharedComponent/app-action-reducer/selectors';
import HeaderPresentational from './header-presentational';

const HeaderFunctional = ({ userDetails, removeUser, title, showAccessLevel, hideAddAffiliate }) => {
	const history = useHistory();
	const [confirmLogoutVisible, setconfirmLogoutVisible] = useState(false);

	const handleLogoutModel = (value = false, logout = false) => {
		setconfirmLogoutVisible(value);
	};

	const handleLogout = () => {
		if (userDetails.authKey) removeUser(userDetails.authKey, history);
	};

	const handleGoback = () => {
		history.go(-1);
	};

	const handleRouting = (path) => {
		history.push(path);
	};
	return (
		<HeaderPresentational
			handleLogoutModel={handleLogoutModel}
			confirmLogoutVisible={confirmLogoutVisible}
			userDetails={userDetails}
			title={title}
			showAccessLevel={showAccessLevel}
			hideAddAffiliate={hideAddAffiliate}
			handleRouting={handleRouting}
			handleLogout={handleLogout}
			handleGoback={handleGoback}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		removeUser: (authKey, history) => dispatch(ActionsApp.creators.removeUser(authKey, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(HeaderFunctional);

export default Connected;
